import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api, TOKEN_KEY, errMsg } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);
  const [authTab, setAuthTab] = useState("login");
  const [checkoutPlan, setCheckoutPlan] = useState(null);

  const openAuth = useCallback((tab = "login") => { setAuthTab(tab); setAuthOpen(true); }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(null); setLoading(false); return null; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
      return null;
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const handleAuth = (data) => { localStorage.setItem(TOKEN_KEY, data.token); setUser(data.user); return data.user; };

  const signup = async (d) => {
    try { const { data } = await api.post("/auth/signup", d); return handleAuth(data); }
    catch (e) { throw new Error(errMsg(e, "Could not create account.")); }
  };
  const login = async (d) => {
    try { const { data } = await api.post("/auth/login", d); return handleAuth(data); }
    catch (e) { throw new Error(errMsg(e, "Login failed.")); }
  };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, signup, login, logout, refresh, authOpen, setAuthOpen, authTab, setAuthTab, openAuth, checkoutPlan, setCheckoutPlan }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
